<template>
  <div>
    <c-card reference="Climb > Cargos" title="Cargos">
      <template slot="icons">
        <icon class="icon" @click="novoCargo" icon="plus"></icon>
        <icon class="icon" @click="abrirFiltros" icon="filter">
          <span v-if="totalFilters" class="card-icons-alert"
            >@{{ totalFilters }}</span
          >
        </icon>
      </template>
      <c-list :items="cargos" class="mb-3">
        <template v-slot:items="item">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex flex-column">
              <div>
                <span
                  style="font-size: .9em; color: #222; font-weight: bold;"
                  >{{ item.data.nome }}</span
                >
              </div>
            </div>
            <div class="list-icons">
              <icon
                class="icon"
                @click="editarCargo(item.data)"
                icon="pen"
              ></icon>
            </div>
          </div>
        </template>
      </c-list>
      <span class="card-divisor mb-3"></span>

      <div class="d-flex justify-content-between">
        <span style="font-size: .8em;font-weight: bold;">
          {{ (page - 1) * limit + 1 }} -
          {{ page * limit > totalRows ? totalRows : page * limit }} /
          {{ totalRows }}
        </span>
        <b-pagination
          v-model="page"
          :total-rows="totalRows"
          :per-page="limit"
          aria-controls="my-table"
          pills
          size="sm"
          class="mb-0"
          @change="loadCargos"
        ></b-pagination>
      </div>
    </c-card>

    <c-modal title="Cargo" v-model="modalCargos" size="full">
      <template v-slot:buttons>
        <button v-if="!loading" @click="salvarCargo">Salvar</button>
        <button v-else @click="salvarCargo" :disabled="loading">
          <b-spinner class="mr-2" small></b-spinner> Cadastrando cargo
        </button>
      </template>

      <b-row>
        <b-col>
          <b-form-group
            label-size="sm"
            v-for="(field, i) in commonFields"
            :key="i"
            :label="field.name"
            :label-for="field.attribute"
          >
            <b-form-input
              id="field.attribute"
              v-if="field.attribute != 'senha'"
              v-model="cargo[field.attribute]"
              type="text"
              :disabled="loading"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>

    <c-modal title="Filtro" v-model="modalFiltro" size="md">
      <template v-slot:buttons>
        <button @click="limparFiltros">Limpar</button>
        <button @click="filtrarCargo">Filtrar</button>
      </template>
      <b-row>
        <b-col>
          <b-form-group label-size="sm" label="Nome" label-for="filtro-nome">
            <b-form-input
              id="filtro-nome"
              v-model="temporaryFilters.nome"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </c-modal>
  </div>
</template>

<script>
import cargosService from "@/services/cargosService.js";

import CList from "@/components/CList.vue";
import CCard from "@/components/CCard.vue";
import CModal from "@/components/CModal.vue";

import { mapActions } from "vuex";

export default {
  name: "Cargos",
  data() {
    return {
      cargos: [],
      cargo: [],
      modalCargos: false,
      commonFields: [{ name: "Nome", attribute: "nome" }],
      modalFiltro: false,
      temporaryFilters: {},
      loading: false,
      filters: {
        nome: null
      },
      limit: 15,
      page: 1,
      totalRows: 0
    };
  },
  methods: {
    ...mapActions("notification", { notificate: "add" }),
    loadCargos(pageNumber) {
      cargosService
        .getAll(this.limit, pageNumber, this.filters)
        .then(res => {
          this.cargos = res.data.data;
          this.totalRows = res.data.totalRows;
        })
        .catch(err => {
          this.notificate({ text: err.message, variant: "danger" });
        });
    },
    abrirFiltros() {
      this.temporaryFilters = JSON.parse(JSON.stringify(this.filters));
      this.modalFiltro = true;
    },
    filtrarCargo() {
      this.page = 1;
      this.modalFiltro = false;
      this.filters = JSON.parse(JSON.stringify(this.temporaryFilters));
      this.loadCargos();
    },
    novoCargo() {
      this.cargo = {
        nome: null
      };

      this.loading = false;
      this.modalCargos = true;
    },
    limparFiltros() {
      Object.keys(this.temporaryFilters).forEach(k => {
        this.temporaryFilters[k] = null;
      });
    },
    salvarCargo() {
      this.loading = true;

      if (this.cargo.id) {
        cargosService
          .update(this.cargo.id, this.cargo)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalCargos = false;

            res = "Cargo alterado com sucesso";

            this.loadCargos();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      } else {
        cargosService
          .create(this.cargo)
          .then(res => {
            this.loading = false;

            if (res.data.errors) {
              Object.keys(res.data.errors).forEach(k => {
                res.data.errors[k].forEach(e => {
                  this.notificate({ text: e, variant: "danger" });
                });
              });
              return;
            }

            this.modalCargos = false;

            res = "Cargo cadastrado com sucesso";

            this.loadCargos();

            this.notificate({ text: res, variant: "success" });
          })
          .catch(err => {
            this.loading = false;
            this.notificate({ text: err.message, variant: "danger" });
          });
      }
    },
    editarCargo(cargo) {
      this.cargo = {
        ...JSON.parse(JSON.stringify(cargo))
      };

      this.modalCargos = true;
    }
  },
  components: {
    CList,
    CCard,
    CModal
  },
  computed: {
    totalFilters() {
      return Object.keys(this.filters).filter(
        k => this.filters[k] && this.filters[k] != ""
      ).length;
    }
  },
  mounted() {
    this.loadCargos(1);
  }
};
</script>
